import React from 'react';
import PropTypes from 'prop-types';

const VettingQuestions = ({ ...props }) => {
  VettingQuestions.propTypes = {
    vettingQuestionInfo: PropTypes.array
  };
  return (
    <React.Fragment>
      {(props.vettingQuestionInfo || []).map((data, index) => (
        (data && data.answer1) && <div key={index} className='vetting-quest-wrapper'>
          <VettingQuestionsWrapper data={data} />
          {((data.childQuestionAnswers) || []).map((childData, childIndex) => (
            childData && childData.answer1 && <div className='vetting-child-quest-wrapper' key={childIndex}>
              <VettingQuestionsWrapper data={childData} />
            </div>)
          )}
        </div>
      ))}
    </React.Fragment>);
};

export const VettingQuestionsWrapper = ({ data }) => {
  VettingQuestionsWrapper.propTypes = {
    data: PropTypes.object
  };
  return <React.Fragment>
    <div><b>{data && data.question}</b></div>
    {(data && data.answer2) ? `$${data && data.answer1} - $${data && data.answer2}` : (Number(data.answer1) ? `$${data.answer1}` : data.answer1)}
  </React.Fragment>;
};

export default VettingQuestions;
